/** A day's Lift workouts and what they did to the day's target. */

import { useWorkoutsForDay } from '../db/queries'
import type { EffectiveTarget } from '../lib/shift'
import { fmtKcal } from '../lib/nutrients'

export function Training({ day, target, isToday }: { day: string; target: EffectiveTarget | null; isToday: boolean }) {
  const workouts = useWorkoutsForDay(day)
  if (!workouts) return null
  const shifted = target && target.kind !== 'none'
  if (workouts.length === 0 && !shifted) return null
  return (
    <div className="card" style={{ marginTop: '1rem', padding: '.9rem 1rem' }}>
      <div className="row">
        <b>{workouts.length ? 'Training' : 'Rest day'}</b>
        {shifted && (
          <span className="num small" style={{ color: target!.delta > 0 ? 'var(--accent)' : 'var(--muted)' }}>
            {target!.delta > 0 ? '+' : '−'}{fmtKcal(Math.abs(target!.delta))} kcal target
          </span>
        )}
      </div>
      {workouts.map((w) => (
        <div key={w.id} className="food-row" style={{ padding: '.5rem 0' }}>
          <div style={{ minWidth: 0 }}>
            <div className="name">{w.title || 'Workout'}</div>
            <div className="muted small">
              {[w.minutes ? `${w.minutes} min` : null,
                (w.parts ?? []).length > 1 ? (w.parts ?? []).map((p) => `${p.label} ~${p.kcal}`).join(' · ') : null,
              ].filter(Boolean).join(' · ')}
            </div>
          </div>
          <span className="num small">~{fmtKcal(w.kcal)} kcal</span>
        </div>
      ))}
      <p className="muted small" style={{ margin: '.4rem 0 0' }}>
        {workouts.length === 0
          ? `Rest days give a little to training days${isToday ? ' — log a workout in Lift and today becomes a training day' : ''}. Your weekly total stays the same.`
          : shifted
            ? 'Estimated burn from Lift (net). Half of it moves onto today as extra carbs, paid for by rest days, so your weekly total stays the same.'
            : 'Estimated burn from Lift (net). Already part of your expenditure, so it isn\'t added on top.'}
      </p>
    </div>
  )
}
